import { render, staticRenderFns } from "./LotReminder.vue?vue&type=template&id=66c62396"
import script from "./LotReminder.vue?vue&type=script&lang=js"
export * from "./LotReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports